import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { AnimatedLink } from '../components/animated-link/AnimatedLink';
import styles from './nav_to_doctrine.module.scss';

export const NavToDoctrine: FC = () => (
  <div className={styles.container}>
    <AnimatedLink href="/" source="marketing_header">
      <span>
        <FormattedMessage id="navigation/NavToDoctrine.tsx/1" />
      </span>
    </AnimatedLink>
  </div>
);
